<nav class="sidebar" [ngClass]="isOpen() ? 'open' : 'close'">
	<div class="title-logo">
		<a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
			<sp-image class="logo-name-image" imageFilename="logo-icon-name"></sp-image>
		</a>
	</div>
	<div class="title-logo-icon">
		<a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
			<sp-image class="logo-icon-image" imageFilename="logo-icon"></sp-image>
		</a>
	</div>

	<ul *ngFor="let item of menu()">
		<li>
			<a
				[routerLink]="!!item.outlet ? getRouterLink(item) : item.routeLink"
				[fragment]="item.fragment"
				[routerLinkActive]="item.activeClass"
				[routerLinkActiveOptions]="{ exact: item.routeLinkActiveOption }"
				[class.active]="item.isActive"
				(click)="handleSelection(item.routeLink)"
			>
				<sp-image *ngIf="item.iconFilename" class="linkImage" [imageFilename]="item.iconFilename"></sp-image>
				<span class="text">{{ item.name }}</span></a
			>
			<span class="tooltip">{{ item.name }}</span>
		</li>
	</ul>
</nav>
